module.exports = __webpack_public_path__ + "img/gas-meter-md.eb993990.svg";